import type { ReactNode } from 'react';

export type StatusLabelVariant = 'default' | 'info' | 'success' | 'warning' | 'danger';

// Spiris "label" badge classes (designsystem docs/badges.md) paired with a matching text colour for the leading dot
const VARIANT_CLASSES: Record<StatusLabelVariant, { label: string; dot: string }> = {
    default: { label: 'label', dot: 'text-secondary' },
    info: { label: 'label label-info', dot: 'text-primary' },
    success: { label: 'label label-success', dot: 'text-success' },
    warning: { label: 'label label-warning', dot: 'text-warning' },
    danger: { label: 'label label-danger', dot: 'text-error' },
};

interface StatusLabelProps {
    variant: StatusLabelVariant;
    // the design system mutes a disabled label, which reads as "terminal" for states such as archived or cancelled
    disabled?: boolean;
    children: ReactNode;
}

const StatusLabel = ({ variant, disabled = false, children }: StatusLabelProps) => {
    const classes = VARIANT_CLASSES[variant];

    return (
        <span className={`${classes.label}${disabled ? ' disabled' : ''} d-inline-flex align-items-center gap-4`}>
            <span className={`${classes.dot} font-size-xs`} aria-hidden="true">
                ●
            </span>
            {children}
        </span>
    );
};

export default StatusLabel;
